// extracted by mini-css-extract-plugin
export default {"topBackground":"_254pwd4IIa80qs2_3-Tjea","inner":"_3acoHRGh4GHTwPYMvQ6Jeo"};